const calculateDifferenceInDays = (date1: Date, date2: Date): number => {
    return Math.abs((date2.getTime() - date1.getTime()) / (1000 * 3600 * 24));
};

const hasDatePassed = (date: Date | string) => {
    if (typeof date === 'string') date = new Date(date);
    return Date.now() > date.getTime();
};

const betweenDates = (dateStart: Date, dateBetween: Date, dateEnd: Date): boolean => {
    const afterDateStart = dateBetween > dateStart;
    const beforeDateEnd = dateBetween < dateEnd;

    return afterDateStart && beforeDateEnd;
};

export { calculateDifferenceInDays, hasDatePassed, betweenDates };
